// extracted by mini-css-extract-plugin
export var integrationButton = "_92-0";